import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { goToRoutePage } from '../../utils/helper';
import { Box, Typography } from '../../utils/material-ui-core';

const AppLogo = () => {
  const pageStyles = LocalPageStyles();
  return (
    <Box
      display="flex"
      className={pageStyles.boxContainer}
      onClick={() => {
        goToRoutePage("Home");
      }}
    >
      <Typography variant="body1" className={pageStyles.iotText}>
        <strong>Sensor</strong>
      </Typography>
      <Typography variant="body2" className={pageStyles.adminText}>
        Admin
      </Typography>
    </Box>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxContainer: {
      justifyItems: "baseline",
      alignItems: "baseline",
      cursor: "pointer",
    },
    iotText: {
      fontSize: 35,
      paddingRight: 2,
      color: theme.palette.type === "dark" ? theme.palette.primary.main : theme.palette.primary.main,
    },
    adminText: {
      fontSize: 35,
      color: theme.palette.type === "dark" ? theme.palette.grey[400] : theme.palette.grey[600],
      fontWeight: 700,
    },
  })
);

export default AppLogo;
